<mat-form-field appearance="outline">
  <input matInput [matDatepicker]="datePicker" [formControl]="control" (dateChange)="onDateChange()" autocomplete="date" required />
  <mat-datepicker-toggle [for]="datePicker" matSuffix></mat-datepicker-toggle>
  <mat-datepicker #datePicker startView="multi-year" (yearSelected)="chosenYearHandler($event, datePicker)"></mat-datepicker>

  @if (control.invalid && control.touched) {
    <mat-error>
      {{ 'InvalidField' | translate }}
    </mat-error>
  }

</mat-form-field>
